<div class="experience-schedules-curriculum-schedules-view-part">
	This is experience-scheduling-page CurriculumSchedules view
</div>